import {
  REPORTING_PERIOD_TOKEN,
  REPORTING_QUARTER_TOKEN,
  SUBMISSION_DEADLINE_TOKEN,
} from '../../../utils/reporting-period';

export const CSC_REPORTING_PERIOD_DEFAULT = 'auto-1';
export const REPORTING_QUARTER = REPORTING_QUARTER_TOKEN;
export const REPORTING_PERIOD = REPORTING_PERIOD_TOKEN;
export const SUBMISSION_DEADLINE = SUBMISSION_DEADLINE_TOKEN;
